import React, { useCallback, useEffect, useState, useRef } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { QuestionsWrapper, WrapperFlex, FaqWrapper, FormWrapper, ButtonCont } from './styles'
import { Form } from '@unform/web'

import * as Yup from 'yup'
import { FormHandles } from '@unform/core'
import { toast } from 'react-toastify'
import getValidationError from 'utils/getValidationErrors'
import CustomTextArea from 'components/Textarea'
import CustomInput from 'components/Input'
import { SEND_MESSAGE } from 'pages/Profile/services'

interface IQuestion {
  open?: boolean
  answer?: string
  question?: string
  faqs: any
}

const HelpForm: React.FC<IQuestion> = ({ faqs }) => {
  const [questions, setQuestions] = useState<IQuestion[]>([])

  useEffect(() => {
    const configQuestions = faqs.map((item) => {
      return {
        ...item,
        open: false,
      }
    })

    setQuestions(configQuestions)
  }, [faqs])

  const handleOpenQuestion = useCallback(
    (index) => {
      const newQustions = questions.map((item, idx) =>
        index === idx ? { ...item, open: !item.open } : item
      )

      setQuestions(newQustions)
    },
    [questions]
  )

  const formRef = useRef<FormHandles>()
  const [loading, setLoading] = useState(false)

  const handleSubmit = useCallback(async (data, { reset }) => {
    try {
      setLoading(true)
      formRef.current?.setErrors({})

      const schema = Yup.object().shape({
        name: Yup.string().required('Informe o seu nome'),
        email: Yup.string().email('Informa um email válido').required('Informe o seu email'),
        phone: Yup.string()
          .min(14, 'Informe um telefone válido')
          .required('Informe o seu telefone'),
        message: Yup.string().required('Escreva sua mensagem'),
      })

      await schema.validate(data, {
        abortEarly: false,
      })

      await SEND_MESSAGE(data)

      setLoading(false)
      reset()
      toast.success('E-mail enviado com sucesso!')
    } catch (err) {
      setLoading(false)
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationError(err)
        return formRef.current?.setErrors(errors)
      }
      if (err.response.status === 401) return

      toast.error('Não foi possível enviar sua mensagem, por favor, tente novamente.')
    }
  }, [])

  return (
    <WrapperFlex>
      <FormWrapper>
        <Form onSubmit={handleSubmit} ref={formRef}>
          <p>
            Caso você não encontre o que procura, entre em{' '}
            <b className="ContactText">contato conosco</b>.
          </p>
          <CustomInput color="#444" name="name" placeholder="Seu nome" />
          <CustomInput
            color="#444"
            name="phone"
            placeholder="Telefone de contato/Whatsapp"
            isPhone
          />
          <CustomInput color="#444" name="email" type="email" placeholder="Seu melhor e-mail" />
          <CustomTextArea name="message" placeholder="Mensagem" rows={5} />
          <ButtonCont>
            <button disabled={loading}>{loading ? 'Enviando...' : 'Enviar'}</button>
            <p>
              <b>Obs</b>.: Você receberá sua resposta via e-mail. Nosso horário de atendimento é de
              segunda a sexta, das 08h às 20h, e aos sábados, das 08h às 12h.
            </p>
          </ButtonCont>
        </Form>
      </FormWrapper>
      <QuestionsWrapper>
        <h1>Perguntas Frequentes – Direção Concursos</h1>
        {questions.map((item, idx) => (
          <FaqWrapper key={idx} onClick={() => handleOpenQuestion(idx)}>
            <div>
              <h2>{item.question}</h2>
              {item.open && <p>{item.answer}</p>}
            </div>
            <button onClick={() => handleOpenQuestion(idx)}>
              {item.open ? <FiChevronUp size={15} /> : <FiChevronDown size={15} />}
            </button>
          </FaqWrapper>
        ))}
      </QuestionsWrapper>
    </WrapperFlex>
  )
}

export default HelpForm
